<p>
    <canvas baseChart
        chartType="polarArea"
        [data]="chartData"
        [labels]="chartLabels"
        [legend]="chartLegend"
        [plugins]="chartPlugins">
    </canvas>

    <button mat-button
        mat-raised-button
        color="primary"
        (click)="randomizer()">
        Randomize
    </button>
</p>
